import React, { useContext, useState } from 'react';
import './AuthModal.scss';
import { Context } from '../../utils/Context';
import { useNavigate } from 'react-router-dom';
import { apiFetch, setAuthToken } from '../../utils/api';
import ErrorText from '../ErrorText/ErrorText';

function AuthModal({ handleAuthModal, authModalDisplay }) {
    const { setLoggedIn, setLoggedOut } = useContext(Context);
    const navigate = useNavigate();

    const [displayError, setDisplayError] = useState(false);
    const [displayServerError, setDisplayServerError] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const onSubmit = async (event) => {
        event.preventDefault();

        setDisplayError(false);
        setDisplayServerError(false);

        try {
            const data = await apiFetch('/api/users/', {
                method: 'POST',
                json: { username, password },
            });

            if (!data?.token) {
                setDisplayError(true);
                setLoggedOut();
                return;
            }

            setAuthToken(data.token);
            setLoggedIn();
            navigate('/edit');
        } catch (error) {
            console.error(error);
            if (error.status === 401) {
                setDisplayError(true);
                setLoggedOut();
            } else {
                setDisplayServerError(true);
            }
        }
    };

    const closeAuthModal = () => {
        handleAuthModal();
        setDisplayError(false);
        setDisplayServerError(false);
    }

    return (
        <div className={authModalDisplay === true ? 'authModal authModal--displayOn' : 'authModal authModal--displayOff'}>
            <form onSubmit={onSubmit} className='authModal_form'>
                <p className='authModal_form_alert'></p>
                <div className='authModal_form_usernameField'>
                    <label>USERNAME</label>
                    <input type='text' name='username' value={username} onChange={(e) => setUsername(e.target.value)} required />
                </div>
                <div className='authModal_form_passwordField'>
                    <label>PASSWORD</label>
                    <input type='password' name='password' value={password} onChange={(e) => setPassword(e.target.value)} required />
                </div>
                <ErrorText errorText={'Accès non-autorisé'} state={displayError}/>
                <ErrorText errorText={'Une erreur est survenue'} state={displayServerError}/>
                <button type='submit' aria-label="Soumettre le formulaire d'authentification" className='authModal_form_button'>LOGIN</button>
            </form>
            <button onClick={closeAuthModal} aria-label="Fermer la modale d'authentification" className='authModal_button'>CLOSE</button>
        </div>
    );
}

export default AuthModal;